export default __webpack_public_path__ + "static/media/outcess22.88f07090.jpeg";